/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feature_Render_Error_MessageInputs */

const en_feature_render_error_message = /** @type {(inputs: Feature_Render_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This section ran into an unexpected problem. Try again to reload it.`)
};

const nl_feature_render_error_message = /** @type {(inputs: Feature_Render_Error_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit onderdeel heeft een onverwacht probleem ondervonden. Probeer het opnieuw om het opnieuw te laden.`)
};

/**
* | output |
* | --- |
* | "This section ran into an unexpected problem. Try again to reload it." |
*
* @param {Feature_Render_Error_MessageInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const feature_render_error_message = /** @type {((inputs?: Feature_Render_Error_MessageInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feature_Render_Error_MessageInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_feature_render_error_message(inputs)
	return en_feature_render_error_message(inputs)
});